<template>
  <div class="kwdrawer__checklist">
    <FormCheckbox
      v-for="kw in keywords"
      :key="kw.id"
      size="small"
      terms
      :value="isSelected(kw.id)"
      @input="$emit('toggle', kw.id)"
    >
      <template #label>
        <!-- Highlight keyword operators (![...] ?[...] * & ~) like the keywords page. -->
        <span class="kwdrawer__kw-value" v-html="highlightKeywordSyntax(kw.value)"></span>
      </template>
    </FormCheckbox>
  </div>
</template>

<script>
import FormCheckbox from '@/components/form/FormCheckbox';
import { highlightKeywordSyntax } from '@/util/keyword-syntax-highlight';

// A category's keywords to tick, in the inbox's keywords panel (TenderKeywordsDrawer): its right
// column on larger screens, under the category on phones.
export default {
  name: 'TenderKeywordChecklist',
  components: { FormCheckbox },
  props: {
    keywords: { type: Array, default: () => [] },
    // Whether a keyword is ticked (the panel's "all keywords" ticks them all).
    isSelected: { type: Function, required: true },
  },
  methods: {
    highlightKeywordSyntax,
  },
};
</script>

<style lang="scss">
.kwdrawer__checklist {
  display: flex;
  flex-direction: column;
}
</style>
